import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { useState as f } from "react";
import { u as h } from "../../../index.esm-BkTadKG5.js";
import { I as v } from "../../../index-D7lh-hNF.js";
import x from "../../icons/eye.js";
import N from "../../icons/eye-slash.js";
import { Button as _ } from "../button/index.js";
import '../../../assets/index3.css';const $ = "_input_5civ1_1", i = {
  input: $,
  "input--action": "_input--action_5civ1_5",
  "input--action--left": "_input--action--left_5civ1_8",
  "input--action--right": "_input--action--right_5civ1_10",
  "input--action--field": "_input--action--field_5civ1_12"
};
function y({
  inputProps: n = { mask: "" },
  id: e,
  registerProps: s,
  leftContent: l,
  rightContent: o,
  upContent: u,
  border: b = !1,
  label: r
}) {
  var p;
  const {
    register: m,
    formState: { errors: c }
  } = h(), a = (p = c == null ? void 0 : c[e]) == null ? void 0 : p.message;
  return /* @__PURE__ */ d("div", { className: `${i.input} b-relative`, children: [
    u ? /* @__PURE__ */ t("div", { className: "input--text", children: u }) : null,
    /* @__PURE__ */ d(
      "div",
      {
        className: `${i["input--action"]} b-py-1 b-px-2 b-overflow-hidden ${b ? "b-border-[1px] b-border-gray-400 b-border-solid b-rounded" : ""} ${a ? "error b-border-red-600" : ""}`,
        children: [
          r ? /* @__PURE__ */ t(
            "label",
            {
              className: "b-absolute b-top-1 b-left-2 b-text-xs b-text-gray-600",
              htmlFor: e,
              children: r
            }
          ) : null,
          l ? /* @__PURE__ */ t(
            "div",
            {
              className: `${i["input--action--left"]} ${i["input--action--content"]}`,
              children: l
            }
          ) : null,
          /* @__PURE__ */ t("span", { className: `b-w-full ${r ? "b-pt-3" : ""}`, children: n.mask ? /* @__PURE__ */ t(
            v,
            {
              ...n,
              "aria-invalid": a ? "true" : "false",
              id: e,
              className: `${i["input--action--field"]} b-p-0 ${n.className ?? ""}`,
              ...m(e, s)
            }
          ) : /* @__PURE__ */ t(
            "input",
            {
              ...n,
              "aria-invalid": a ? "true" : "false",
              id: e,
              className: `${i["input--action--field"]} b-p-0 ${n.className ?? ""} `,
              ...m(e, s)
            }
          ) }),
          o ? /* @__PURE__ */ t(
            "div",
            {
              className: `${i["input--action--right"]} ${i["input--action--content"]}`,
              children: o
            }
          ) : null
        ]
      }
    ),
    a ? /* @__PURE__ */ t(
      "div",
      {
        role: "alert",
        className: `${i["input--errors"]} b-text-end b-text-red-600 b-text-sm`,
        children: a
      }
    ) : null
  ] });
}
function F(n) {
  const [e, s] = f(!1);
  return /* @__PURE__ */ t(
    y,
    {
      ...n,
      inputProps: {
        ...n.inputProps,
        mask: "",
        type: e ? "text" : "password"
      },
      rightContent: /* @__PURE__ */ t("div", { className: "b-flex b-items-center b-justify-center b-h-full", children: /* @__PURE__ */ t(
        _,
        {
          styleType: "icon",
          className: "b-opacity-70",
          onClick: () => s((l) => !l),
          children: /* @__PURE__ */ t("div", { className: "b-h-5 b-w-5", children: e ? /* @__PURE__ */ t(x, {}) : /* @__PURE__ */ t(N, {}) })
        }
      ) })
    }
  );
}
export {
  F as PasswordInput,
  y as default
};
